var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-scroll-page",
    { staticClass: "w-container" },
    [
      _c(
        "w-card",
        { attrs: { grow: "" } },
        [
          _c(
            "w-card-content",
            [
              _c("app-frequency-settings-edit", {
                attrs: { state: _vm.state },
              }),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }